(() => {
    const bannerItSelf = document.querySelector(".custom-banner_wrapper"); 
    const closeButton = document.querySelector(".custom-banner_wrapper .close"); 
    
    if(closeButton) {
        closeButton.addEventListener("click", (event) => {
            event.preventDefault();
            bannerItSelf.setAttribute("style","display:none");
        });
    }
})()



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/customBanner.js